import React, { useEffect, useState } from 'react'
import { vid_gold } from '../../assets'
import { twMerge } from 'tailwind-merge'
import useVideoControls from '../../hooks/useVideoControls';
import useMouse from '../../hooks/useMouse';
import ButtonUI from './ButtonUI';
import useAnimLanding from '../../animations/animLanding';
import { motionValue, useMotionValueEvent } from 'framer-motion';

const Video = ({ children, loopVideo = true, hasPlayButton = true, playButtonOnClick, hasToggleButton, toggleOnClick, dim, id, src, className, ...props }) => {


  const { videoRef, isPlaying, togglePlayPause, unmute } = useVideoControls(src)
  const { toDefault, toPlay } = useMouse()

  const { scrolledPixels, } = useAnimLanding();

  const [volume] = useState(motionValue(1))

  useMotionValueEvent(scrolledPixels, 'change', l => {
    const newVolume = Math.max(1 - l / window.innerHeight, 0) // Volume fades as you scroll
    // console.log(volume.get())
    volume.set(newVolume)
  })

  useMotionValueEvent(volume, 'change', (v) => {
    if (videoRef.current) {
      videoRef.current.volume = v
    }
  })

  useEffect(() => {
    if (videoRef.current.muted || isPlaying) {
      unmute()
    }
  }, [isPlaying, unmute, videoRef])

  return (
    <>
      <video
        onClick={togglePlayPause}
        id={id}
        ref={videoRef}
        onMouseEnter={toPlay}
        onMouseLeave={toDefault}
        className={twMerge(
          'object-cover full oneSecond relative',
          className,
          dim && ' brightness-[.4] group-hover:brightness-[1]'
        )}
        autoPlay
        muted={true}
        loop={loopVideo}
        controls={false}
        controlsList='nodownload nooptions noprogressbar'
        playsInline
      >
        <source src={src || vid_gold} />
      </video>

      <div className='flex scale-[.9] z-[1] absolute bottom-6 gap-2 right-6 center'>
        <>
          {hasToggleButton &&
            <ButtonUI variant={"primary"} onClick={toggleOnClick}
              className={"capitalize text-xs muted hover:unmute"}>
              focus
            </ButtonUI>
          }

          {/*   {hasPlayButton &&
            <ButtonUI variant={"discreet"} onClick={playButtonOnClick || togglePlayPause}
              className={"delay-150 quick min-w-[6ch] animate-slideright bg-transparent"}>
              <span className='relative flex rounded-full overflow-clip aspect-square center size-7'>
                <i className={`${isPlaying ? "ri-pause-fill" : " ri-play-fill"}  flex w-8 h-8 text-white brightness-105 text-center center`} />
              </span>
            </ButtonUI>
          } */}
        </>

        {children}
      </div>
    </>

  )
};

export default Video;
